import { render } from "./AdminNavbarHeaderComponent.vue?vue&type=template&id=35e890d3&scoped=true&ts=true"
import script from "./AdminNavbarHeaderComponent.vue?vue&type=script&lang=ts"
export * from "./AdminNavbarHeaderComponent.vue?vue&type=script&lang=ts"

import "./AdminNavbarHeaderComponent.vue?vue&type=style&index=0&id=35e890d3&scoped=true&lang=css"

import exportComponent from "G:\\MD\\MyFiles\\Work\\Projects\\OshElektro\\SMVueJS\\smv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e890d3"]])

export default __exports__